// daten.js
// Funktrainer — Inhalt
// Hier steht kein Code, nur Listen. Diese Datei darf jemand pflegen,
// der den Behelf kennt aber nicht programmiert.
//
// ACHTUNG: Die Formulierungen unten sind Platzhalter und gegen den
// echten Behelf zu pruefen, bevor jemand damit uebt.


// Die Kanaele kommen aus derselben Liste wie im Funkgeraet — wird die
// Kanalliste fuer einen Kanton getauscht, aendert sie sich hier mit.
import { kanaele } from './Kanaele'


export const inventar = {

  // Funknamen. Per Behelf immer die Funktionsbezeichnung, nie Personennamen.
  // Der Organisationszusatz (z.B. "KP Front, Berna") kommt nur dazu, wenn
  // mehrere gleiche Stationen im Netz sind — das ist eine Eigenschaft der
  // Lage, nicht der Station, und gehoert darum in die Uebung, nicht hierher.
  //
  // Die Stationen bilden EINEN Einsatz ab: eine Zivilschutzkompanie
  // (Gliederung nach Handbuch Zivilschutz 2024, Abb. 5) bei einem Unwetter,
  // dazu die Partner im Bevoelkerungsschutz, mit denen sie zusammenarbeitet.
  //   org:    zivilschutz | polizei | feuerwehr | sanitaet
  //   leitet: true bei den Kommandoposten. Nur sie fuehren eine
  //           Verbindungskontrolle durch oder befehlen einen Kanalwechsel.
  // Wer welche Meldung sendet und empfaengt, steht bei der Meldung.
  stationen: [
    // Zivilschutz: Kommando und Fuehrungsunterstuetzung
    { id: 'kp_rueck',             rufname: 'KP Rück',             org: 'zivilschutz', leitet: true },
    { id: 'kp_front',             rufname: 'KP Front',            org: 'zivilschutz', leitet: true },
    { id: 'infostelle',           rufname: 'Infostelle',          org: 'zivilschutz' },
    { id: 'patrouille_eins',      rufname: 'Patrouille Eins',     org: 'zivilschutz' },
    { id: 'verkehrsposten_nord',  rufname: 'Verkehrsposten Nord', org: 'zivilschutz' },
    // Zivilschutz: Betreuung, Pioniere, Logistik, Kulturgueterschutz
    { id: 'sammelstelle',         rufname: 'Sammelstelle',        org: 'zivilschutz' },
    { id: 'betreuungsstelle',     rufname: 'Betreuungsstelle',    org: 'zivilschutz' },
    { id: 'pionierzug',           rufname: 'Pionierzug',          org: 'zivilschutz' },
    { id: 'materialstelle',       rufname: 'Materialstelle',      org: 'zivilschutz' },
    { id: 'kulturgueterschutz',   rufname: 'Kulturgüterschutz',   org: 'zivilschutz' },
    // Partner
    { id: 'polizei',              rufname: 'Polizei',             org: 'polizei' },
    { id: 'feuerwehr',            rufname: 'Feuerwehr',           org: 'feuerwehr' },
    { id: 'sanitaetshilfsstelle', rufname: 'Sanitätshilfsstelle', org: 'sanitaet' }
  ],

  // Meldungstexte ohne Anfuehrungszeichen — die « » setzt die Uebung beim
  // Zusammenbauen, damit der Text auch ausserhalb eines Meldungsblocks
  // brauchbar ist.
  //   von:    welche Stationen diese Meldung sinnvoll senden (ids von oben)
  //   an:     welche Stationen sie sinnvoll empfangen. Bei einer Meldung an
  //           alle sind das die Stationen, die im Netz zuhoeren.
  //   anAlle: true, wenn die Meldung auch als «An Alle» Sinn ergibt
  //           (einseitige Uebermittlung, Funkverkehr mit 3+ Stationen). Sie
  //           braucht dann bei "an" mindestens zwei Stationen ausser dem
  //           Absender.
  // Eine neue Meldung braucht immer "von" und "an", sonst wird sie nie
  // gewuerfelt.
  meldungen: [
    // Kommandoposten
    { id: 'abloesung_1800', funktext: 'Ablösung trifft um 1800 ein', anAlle: true,
      von: ['kp_rueck'],
      an:  ['kp_front', 'pionierzug', 'betreuungsstelle', 'sammelstelle', 'materialstelle', 'infostelle', 'verkehrsposten_nord', 'patrouille_eins', 'kulturgueterschutz'] },
    { id: 'rapport_1700', funktext: 'Rapport der Zugchefs um 1700', anAlle: true,
      von: ['kp_rueck'],
      an:  ['kp_front', 'pionierzug', 'betreuungsstelle', 'materialstelle', 'infostelle', 'kulturgueterschutz'] },
    { id: 'gewitter', funktext: 'Unwetterwarnung, Gewitter ab 1500', anAlle: true,
      von: ['kp_rueck'],
      an:  ['kp_front', 'pionierzug', 'betreuungsstelle', 'sammelstelle', 'materialstelle', 'verkehrsposten_nord', 'patrouille_eins'] },
    { id: 'evakuierung', funktext: 'Evakuierung Quartier Au angeordnet', anAlle: true,
      von: ['kp_front', 'polizei'],
      an:  ['kp_rueck', 'kp_front', 'betreuungsstelle', 'sammelstelle', 'infostelle', 'feuerwehr', 'polizei'] },

    // Polizei
    { id: 'hauptstrasse_gesperrt', funktext: 'Hauptstrasse beim Dorfeingang gesperrt', anAlle: true,
      von: ['polizei'],
      an:  ['kp_front', 'kp_rueck', 'feuerwehr', 'sanitaetshilfsstelle', 'verkehrsposten_nord', 'materialstelle'] },
    { id: 'umleitung', funktext: 'Umleitung über Industriestrasse signalisiert', anAlle: true,
      von: ['polizei', 'verkehrsposten_nord'],
      an:  ['kp_front', 'polizei', 'feuerwehr', 'sanitaetshilfsstelle', 'materialstelle', 'verkehrsposten_nord'] },
    { id: 'quartier_geraeumt', funktext: 'Quartier Au vollständig geräumt',
      von: ['polizei', 'feuerwehr'],
      an:  ['kp_front', 'kp_rueck'] },

    // Feuerwehr
    { id: 'keller_ueberflutet', funktext: 'Keller Bahnhofstrasse überflutet, Pumpe nötig',
      von: ['feuerwehr'],
      an:  ['kp_front', 'kp_rueck'] },
    { id: 'brand_geloescht', funktext: 'Brand in der Scheune gelöscht',
      von: ['feuerwehr'],
      an:  ['kp_front', 'polizei'] },
    { id: 'gefahrenzone', funktext: 'Gefahrenzone bis Kreuzung Nord erweitert', anAlle: true,
      von: ['feuerwehr'],
      an:  ['kp_front', 'polizei', 'sanitaetshilfsstelle', 'pionierzug', 'verkehrsposten_nord'] },

    // Sanitaet
    { id: 'verletzte_unterwegs', funktext: 'Zwei Leichtverletzte unterwegs zu euch',
      von: ['feuerwehr', 'pionierzug', 'kp_front'],
      an:  ['sanitaetshilfsstelle'] },
    { id: 'patienten_abtransportiert', funktext: 'Alle Patienten abtransportiert',
      von: ['sanitaetshilfsstelle'],
      an:  ['kp_front', 'feuerwehr', 'polizei'] },
    { id: 'plaetze_frei', funktext: 'Zehn Behandlungsplätze frei',
      von: ['sanitaetshilfsstelle'],
      an:  ['kp_front', 'feuerwehr'] },
    { id: 'person_geborgen', funktext: 'Eine verletzte Person geborgen',
      von: ['pionierzug', 'feuerwehr'],
      an:  ['kp_front', 'sanitaetshilfsstelle'] },

    // Pioniere
    { id: 'keller_ausgepumpt', funktext: 'Keller Schulhaus ausgepumpt',
      von: ['pionierzug', 'feuerwehr'],
      an:  ['kp_front', 'kp_rueck'] },
    { id: 'sandsackdamm', funktext: 'Sandsackdamm am Dorfbach erstellt',
      von: ['pionierzug'],
      an:  ['kp_front', 'kp_rueck', 'feuerwehr'] },
    { id: 'baum_entfernt', funktext: 'Umgestürzter Baum Waldstrasse entfernt',
      von: ['pionierzug', 'feuerwehr'],
      an:  ['kp_front', 'polizei', 'verkehrsposten_nord'] },
    { id: 'beleuchtung', funktext: 'Schadenplatzbeleuchtung in Betrieb',
      von: ['pionierzug'],
      an:  ['kp_front', 'feuerwehr'] },
    { id: 'notstrom', funktext: 'Notstrom im Gemeindehaus läuft',
      von: ['pionierzug'],
      an:  ['kp_rueck', 'kp_front'] },

    // Patrouille (Erkundung)
    { id: 'bruecke', funktext: 'Brücke über den Dorfbach unpassierbar',
      von: ['patrouille_eins'],
      an:  ['kp_front', 'kp_rueck'] },
    { id: 'hang', funktext: 'Hang oberhalb Waldweg rutscht',
      von: ['patrouille_eins', 'pionierzug'],
      an:  ['kp_front', 'kp_rueck', 'feuerwehr'] },

    // Betreuung
    { id: 'personen_unterwegs', funktext: 'Zwölf Personen unterwegs zu euch',
      von: ['sammelstelle', 'polizei'],
      an:  ['betreuungsstelle'] },
    { id: 'unterkunft_bereit', funktext: 'Unterkunft für vierzig Personen bereit',
      von: ['betreuungsstelle'],
      an:  ['kp_rueck', 'kp_front', 'sammelstelle'] },
    { id: 'personen_registriert', funktext: 'Achtzehn Personen registriert und verpflegt',
      von: ['betreuungsstelle'],
      an:  ['kp_rueck', 'kp_front'] },
    { id: 'turnhalle_bezogen', funktext: 'Turnhalle bezogen, bereit für Evakuierte',
      von: ['sammelstelle'],
      an:  ['kp_rueck', 'kp_front', 'betreuungsstelle'] },
    { id: 'hotline', funktext: 'Telefonhotline für Angehörige in Betrieb',
      von: ['betreuungsstelle', 'infostelle'],
      an:  ['kp_rueck'] },

    // Infostelle
    { id: 'infoblatt', funktext: 'Informationsblatt zur Evakuierung benötigt',
      von: ['infostelle'],
      an:  ['kp_rueck'] },
    { id: 'anfragen_trinkwasser', funktext: 'Viele Anfragen zum Trinkwasser',
      von: ['infostelle'],
      an:  ['kp_rueck'] },

    // Logistik
    { id: 'sandsaecke', funktext: 'Fünfhundert Sandsäcke unterwegs zu euch',
      von: ['materialstelle'],
      an:  ['pionierzug', 'kp_front'] },
    { id: 'pumpen', funktext: 'Zwei Pumpen zum Abholen bereit',
      von: ['materialstelle'],
      an:  ['pionierzug', 'kp_front', 'feuerwehr'] },
    { id: 'verpflegung', funktext: 'Verpflegung trifft um 1200 ein',
      von: ['materialstelle'],
      an:  ['pionierzug', 'betreuungsstelle', 'kp_front'] },

    // Verkehrsposten
    { id: 'posten_bezogen', funktext: 'Posten Kreuzung Nord bezogen',
      von: ['verkehrsposten_nord'],
      an:  ['kp_front', 'polizei'] },

    // Kulturgueterschutz
    { id: 'archiv', funktext: 'Archiv im Gemeindehaus geräumt',
      von: ['kulturgueterschutz'],
      an:  ['kp_rueck', 'kp_front'] },
    { id: 'kirche', funktext: 'Kulturgut aus der Kirche in Sicherheit',
      von: ['kulturgueterschutz'],
      an:  ['kp_rueck', 'kp_front'] }
  ],

  // Woerter, die im Funk gebraeuchlich sind, aber NICHT im Behelf stehen —
  // Englisch, Militaerjargon, Umgangssprache. Der Behelf hat fuer jede
  // dieser Absichten ein eigenes Wort: "kommen" meint ANTWORTEN, "ende"
  // meint SCHLUSS. Darum sind sie immer falsch, egal wie die Lage ist —
  // genau das macht sie als Ablenker brauchbar.
  // Klein geschrieben wie die Redewendungen in den Bausteinen: sonst waere
  // der falsche Baustein schon an der Schreibweise zu erkennen.
  fremdwoerter: [
    { id: 'roger',        wort: 'roger'        },
    { id: 'over',         wort: 'over'         },
    { id: 'over_and_out', wort: 'over and out' },
    { id: 'ende',         wort: 'ende'         },
    { id: 'kommen',       wort: 'kommen'       },
    { id: 'bitte_kommen', wort: 'bitte kommen' },
    { id: 'alles_klar',   wort: 'alles klar'   },
    { id: 'okay',         wort: 'okay'         }
  ],

  // Angabe der Verstaendlichkeit (Behelf S. 8). Gross geschrieben wie im
  // Behelf.
  verstaendlichkeit: [
    { id: 'one',   wort: 'ONE',   bedeutung: 'schlechte bis unbrauchbare Verständlichkeit' },
    { id: 'two',   wort: 'TWO',   bedeutung: 'knapp genügende bis genügende Verständlichkeit (Wiederholungen sind möglich)' },
    { id: 'three', wort: 'THREE', bedeutung: 'gut verständlich' }
  ],

  // Kanaele fuer den Kanalwechsel, mit Nummer ("number") wie am Geraet.
  kanaele

}


// Die Ablaeufe. Ein Eintrag pro Kategorie, die Kategorie steht im Feld
// "kategorie". "name" und "beschreibung" stehen so im Auswahlmenue.
// Jeder Eintrag hat dieselbe Form wie das Grundschema unten — eine neue
// Kategorie ist ein neuer Eintrag hier, kein neuer Code.
export const schemata = [

  // ─── Grundschema: eine Meldung an eine Station ─────────────────
  {

    id: 'meldung-standard',
    name: 'Grundschema',
    beschreibung: 'Eine Meldung an eine Station: An …, von …, Text, antworten.',
    kategorie: 'grundschema',

    // Was gewuerfelt werden muss. Reihenfolge zaehlt: eine Rolle mit
    // "nichtGleich" muss NACH der Rolle stehen, auf die sie zeigt.
    // Zuerst die Meldung, dann wer sie sinnvoll sendet und empfaengt.
    rollen: [
      { name: 'meldung',    typ: 'meldungen' },
      { name: 'absender',   typ: 'stationen', aus: 'meldung.von' },
      { name: 'empfaenger', typ: 'stationen', aus: 'meldung.an', nichtGleich: 'absender' },
      { name: 'fremd1',     typ: 'fremdwoerter' },
      { name: 'fremd2',     typ: 'fremdwoerter', nichtGleich: 'fremd1' }
    ],

    // Die Zuege des Ablaufs, in RICHTIGER Reihenfolge. Ein Zug = eine
    // Uebermittlung einer Station. Das Grundschema hat nur einen Zug; eine
    // Verbindungskontrolle hat drei.
    //   spricht:  welche Rolle (aus "rollen") diesen Zug sendet
    //   slots:    die Bausteine des Spruchs, in RICHTIGER Reihenfolge.
    //             "regel" erscheint in der Rueckmeldung, wenn der Baustein
    //             an der falschen Stelle liegt.
    //             "text" darf eine Liste gleichwertiger Fassungen sein
    //             (['richtig', 'verstanden']); dann wird eine gewuerfelt.
    //   ablenker: Bausteine, die NICHT in diesen Spruch gehoeren. Sie liegen
    //             nur im Vorrat, wenn Ablenker eingeschaltet sind.
    //             Ein Ablenker muss nach einer REGEL falsch sein, nicht nur
    //             nach der Lage: ein zweiter gueltiger Rufname waere hier
    //             nicht als falsch erkennbar, weil die Lage den Empfaenger
    //             nicht nennt.
    //             "regel" erscheint in der Rueckmeldung, wenn der Baustein im
    //             Spruch liegt.
    //             "ersetzt" nennt die Rolle des Slots, an dessen Stelle der
    //             Ablenker als Fehler stehen kann (Uebungsarten der
    //             Fehlersuche).
    zuege: [
      {
        spricht: 'absender',
        slots: [
          { rolle: 'adressat', text: 'An {empfaenger.rufname}', regel: 'Der Adressat steht zuerst.' },
          { rolle: 'absender', text: 'von {absender.rufname}',  regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',   text: '{meldung.funktext}',      regel: 'Der Inhalt steht nach dem Absender.' },
          { rolle: 'schluss',  text: 'antworten',               regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      }
    ],

    // Was der Lernende vor der Aufgabe liest.
    kontext: 'Du bist {absender.rufname}.'

  },

  // ─── Funkverkehr zwischen zwei Stationen (Behelf S. 11) ───────
  // Drei Zuege. Der erste ist das Grundschema; "Meldung:" bleibt draussen,
  // wie dort. Schreibweise wie im Behelf, nur ohne Grossbuchstaben am
  // Satzanfang — sonst verraet die Grossschreibung den ersten Baustein.
  // Quittiert wird MIT Inhalt ("verstanden" + was verstanden wurde), der
  // Absender bestaetigt mit "richtig". Der Behelf schreibt "Meldung
  // verstanden" / "verstanden Schluss" — bewusst abweichend, Entscheid des
  // Nutzers 2026-10-16: wer quittiert, soll sagen, was er verstanden hat.
  // Gilt ebenso fuer "Funkverkehr, 3+ Stationen".
  {
    id: 'funkverkehr-2',
    name: 'Funkverkehr, 2 Stationen',
    beschreibung: 'Meldung, Quittierung und Schluss zwischen zwei Stationen.',
    kategorie: 'funkverkehr-2',

    // Zuerst die Meldung, dann wer sie sinnvoll sendet und empfaengt.
    rollen: [
      { name: 'meldung',    typ: 'meldungen' },
      { name: 'absender',   typ: 'stationen', aus: 'meldung.von' },
      { name: 'empfaenger', typ: 'stationen', aus: 'meldung.an', nichtGleich: 'absender' },
      { name: 'fremd1',     typ: 'fremdwoerter' },
      { name: 'fremd2',     typ: 'fremdwoerter', nichtGleich: 'fremd1' }
    ],

    zuege: [
      {
        spricht: 'absender',
        slots: [
          { rolle: 'adressat', text: 'An {empfaenger.rufname}', regel: 'Der Adressat steht zuerst.' },
          { rolle: 'absender', text: 'von {absender.rufname}',  regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',   text: '{meldung.funktext}',      regel: 'Der Inhalt steht nach dem Absender.' },
          { rolle: 'schluss',  text: 'antworten',               regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'empfaenger',
        slots: [
          { rolle: 'absender',    text: '{empfaenger.rufname}', regel: 'Wer quittiert, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung', text: 'verstanden',           regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'inhalt',      text: '{meldung.funktext}',   regel: 'Wer quittiert, wiederholt den Inhalt.' },
          { rolle: 'schluss',     text: 'antworten',            regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          { rolle: 'bestaetigung', text: 'richtig', regel: 'Zuerst wird die Quittierung bestätigt.' },
          { rolle: 'schluss',      text: 'Schluss', regel: 'Schluss beendet die Übermittlung und steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      }
    ],

    kontext: '{absender.rufname} hat eine Meldung für {empfaenger.rufname}: {meldung.funktext}.'
  },

  // ─── Verbindungskontrolle zwischen zwei Stationen (Behelf S. 9) ─
  // Jede Station gibt an, wie gut sie die andere hoert. Die beiden Werte
  // werden unabhaengig gewuerfelt, koennen also auch gleich sein.
  {
    id: 'verbindungskontrolle-2',
    name: 'Verbindungskontrolle, 2 Stationen',
    beschreibung: 'Aufruf, Antwort mit der Verständlichkeit, Schluss.',
    kategorie: 'verbindungskontrolle-2',

    rollen: [
      // Ein Kommandoposten prueft die Verbindung im Netz des Zivilschutzes.
      { name: 'absender',   typ: 'stationen', wo: { leitet: true } },
      { name: 'empfaenger', typ: 'stationen', wo: { org: 'zivilschutz' }, nichtGleich: 'absender' },
      // wie gut der Empfaenger den Absender hoert, und umgekehrt
      { name: 'hoertEmpfaenger', typ: 'verstaendlichkeit' },
      { name: 'hoertAbsender',   typ: 'verstaendlichkeit' },
      { name: 'fremd1',     typ: 'fremdwoerter' },
      { name: 'fremd2',     typ: 'fremdwoerter', nichtGleich: 'fremd1' }
    ],

    zuege: [
      {
        spricht: 'absender',
        slots: [
          { rolle: 'adressat', text: 'An {empfaenger.rufname}', regel: 'Der Adressat steht zuerst.' },
          { rolle: 'absender', text: 'von {absender.rufname}',  regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',   text: 'Verbindungskontrolle',    regel: 'Die Inhaltsbezeichnung steht nach dem Absender.' },
          { rolle: 'schluss',  text: 'antworten',               regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'empfaenger',
        slots: [
          { rolle: 'absender',          text: '{empfaenger.rufname}',   regel: 'Wer antwortet, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung',       text: 'verstanden',             regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'verstaendlichkeit', text: '{hoertEmpfaenger.wort}', regel: 'Die Verständlichkeit folgt nach der Quittierung.' },
          { rolle: 'schluss',           text: 'antworten',              regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          { rolle: 'quittierung',       text: 'verstanden',           regel: 'Zuerst wird der Empfang bestätigt.' },
          { rolle: 'verstaendlichkeit', text: '{hoertAbsender.wort}', regel: 'Die Verständlichkeit folgt nach der Quittierung.' },
          { rolle: 'schluss',           text: 'Schluss',              regel: 'Schluss beendet die Übermittlung und steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      }
    ],

    kontext: '{absender.rufname} prüft die Verbindung zu {empfaenger.rufname}. {empfaenger.rufname} hört {absender.rufname} mit {hoertEmpfaenger.wort}, umgekehrt {hoertAbsender.wort}.'
  },

  // ─── Einseitige Uebermittlung (Behelf S. 11) ───────────────────
  // Ein einziger Zug, niemand antwortet. Die Meldung wird wiederholt (der
  // Behelf: "kann", sein Beispiel tut es). "Meldung:" bleibt draussen, wie
  // ueberall.
  // Gleichlautende Bausteine kommen doppelt vor und sind austauschbar.
  // Darum haben beide dieselbe Regel — welchen der beiden der Lernende
  // erwischt, darf die Rueckmeldung nicht aendern.
  {
    id: 'einseitig',
    name: 'Einseitige Übermittlung',
    beschreibung: 'Eine Meldung an alle, wiederholt, ohne Antwort.',
    kategorie: 'einseitig',

    rollen: [
      { name: 'meldung',  typ: 'meldungen', wo: { anAlle: true } },
      { name: 'absender', typ: 'stationen', aus: 'meldung.von' },
      { name: 'fremd1',   typ: 'fremdwoerter' },
      { name: 'fremd2',   typ: 'fremdwoerter', nichtGleich: 'fremd1' }
    ],

    zuege: [
      {
        spricht: 'absender',
        slots: [
          { rolle: 'adressat',     text: 'An Alle',                regel: 'Auch die Wiederholung beginnt mit dem Adressaten.' },
          { rolle: 'absender',     text: 'von {absender.rufname}', regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',       text: '{meldung.funktext}',     regel: 'Der Inhalt steht nach dem Absender.' },
          { rolle: 'wiederholung', text: 'ich wiederhole',         regel: '«ich wiederhole» steht zwischen der Meldung und ihrer Wiederholung.' },
          { rolle: 'adressat',     text: 'An Alle',                regel: 'Auch die Wiederholung beginnt mit dem Adressaten.' },
          { rolle: 'absender',     text: 'von {absender.rufname}', regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',       text: '{meldung.funktext}',     regel: 'Der Inhalt steht nach dem Absender.' },
          { rolle: 'schluss',      text: 'Schluss',                regel: 'Schluss beendet die Übermittlung und steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          // Falsch nach der Lage, aber die Lage sagt es ausdruecklich.
          { text: 'antworten',     regel: 'Bei der einseitigen Übermittlung antwortet niemand, also kein «antworten».', ersetzt: 'schluss' }
        ]
      }
    ],

    kontext: 'Du bist {absender.rufname}. Meldung an alle im Netz: {meldung.funktext}. Niemand antwortet, du wiederholst die Meldung.'
  },

  // ─── Funkverkehr zwischen drei und mehr Stationen (Behelf S. 12) ─
  // "An Alle", dann ruft der Absender die Stationen einzeln zum Quittieren
  // auf (Aufrufkette). Der Behelf erlaubt auch "An KP Front und Infostelle";
  // hier steht die Form aus seinem Beispiel.
  {
    id: 'funkverkehr-3',
    name: 'Funkverkehr, 3+ Stationen',
    beschreibung: 'Meldung an alle, jede Station quittiert auf Aufruf, dann Schluss.',
    kategorie: 'funkverkehr-3',

    rollen: [
      // Eine Meldung an alle; die beiden anderen Stationen hoeren sie im Netz.
      { name: 'meldung',  typ: 'meldungen', wo: { anAlle: true } },
      { name: 'absender', typ: 'stationen', aus: 'meldung.von' },
      { name: 'erste',    typ: 'stationen', aus: 'meldung.an', nichtGleich: 'absender' },
      { name: 'zweite',   typ: 'stationen', aus: 'meldung.an', nichtGleich: ['absender', 'erste'] },
      { name: 'fremd1',   typ: 'fremdwoerter' },
      { name: 'fremd2',   typ: 'fremdwoerter', nichtGleich: 'fremd1' }
    ],

    zuege: [
      {
        spricht: 'absender',
        slots: [
          { rolle: 'adressat', text: 'An Alle',                regel: 'Der Adressat steht zuerst.' },
          { rolle: 'absender', text: 'von {absender.rufname}', regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',   text: '{meldung.funktext}',     regel: 'Der Inhalt steht nach dem Absender.' },
          { rolle: 'aufruf',   text: '{erste.rufname}',        regel: 'Nach dem Inhalt wird die Station aufgerufen, die zuerst quittiert.' },
          { rolle: 'schluss',  text: 'antworten',              regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          // Falsch nach der Lage — sie sagt, wer zuerst quittiert.
          { text: '{zweite.rufname}', regel: 'Zuerst wird die Station aufgerufen, die laut Lage zuerst quittiert.', ersetzt: 'aufruf' }
        ]
      },
      {
        spricht: 'erste',
        slots: [
          { rolle: 'absender',    text: '{erste.rufname}',      regel: 'Wer quittiert, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung', text: 'verstanden',           regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'inhalt',      text: '{meldung.funktext}',   regel: 'Wer quittiert, wiederholt den Inhalt.' },
          { rolle: 'schluss',     text: 'antworten',            regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          // Beides richtig, je nach ZSO (Nutzer, 2026-10-16) — einer wird gewuerfelt.
          { rolle: 'bestaetigung', text: ['richtig', 'verstanden'], regel: 'Zuerst wird die Quittierung bestätigt.' },
          { rolle: 'aufruf',       text: '{zweite.rufname}',        regel: 'Danach wird die nächste Station aufgerufen.' },
          { rolle: 'schluss',     text: 'antworten',        regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          // Falsch nach dem Ablauf — diese Station hat schon quittiert.
          { text: '{erste.rufname}', regel: 'Aufgerufen wird die Station, die noch nicht quittiert hat.', ersetzt: 'aufruf' }
        ]
      },
      {
        spricht: 'zweite',
        slots: [
          { rolle: 'absender',    text: '{zweite.rufname}',     regel: 'Wer quittiert, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung', text: 'verstanden',           regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'inhalt',      text: '{meldung.funktext}',   regel: 'Wer quittiert, wiederholt den Inhalt.' },
          { rolle: 'schluss',     text: 'antworten',            regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          { rolle: 'bestaetigung', text: 'richtig', regel: 'Zuerst wird die Quittierung bestätigt.' },
          { rolle: 'schluss',      text: 'Schluss', regel: 'Schluss beendet die Übermittlung und steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      }
    ],

    kontext: '{absender.rufname} hat eine Meldung für alle Stationen im Netz: {meldung.funktext}. Im Netz sind {erste.rufname} und {zweite.rufname}; {erste.rufname} quittiert zuerst.'
  },

  // ─── Verbindungskontrolle zwischen drei und mehr Stationen (S. 10) ─
  // "Jede Station gibt die hörbare Verständlichkeit der Gegenstation an."
  // Vier Werte, jeder unabhaengig gewuerfelt. Aufrufkette wie beim
  // Funkverkehr mit drei Stationen, mit denselben Ablenkern (falsche Station).
  {
    id: 'verbindungskontrolle-3',
    name: 'Verbindungskontrolle, 3+ Stationen',
    beschreibung: 'Aufruf an alle, jede Station antwortet auf Aufruf mit der Verständlichkeit.',
    kategorie: 'verbindungskontrolle-3',

    rollen: [
      // Ein Kommandoposten fuehrt das Netz des Zivilschutzes.
      { name: 'absender', typ: 'stationen', wo: { leitet: true } },
      { name: 'erste',    typ: 'stationen', wo: { org: 'zivilschutz' }, nichtGleich: 'absender' },
      { name: 'zweite',   typ: 'stationen', wo: { org: 'zivilschutz' }, nichtGleich: ['absender', 'erste'] },
      // wer hoert wen wie gut
      { name: 'ersteHoert',     typ: 'verstaendlichkeit' },
      { name: 'hoertErste',     typ: 'verstaendlichkeit' },
      { name: 'zweiteHoert',    typ: 'verstaendlichkeit' },
      { name: 'hoertZweite',    typ: 'verstaendlichkeit' },
      { name: 'fremd1',   typ: 'fremdwoerter' },
      { name: 'fremd2',   typ: 'fremdwoerter', nichtGleich: 'fremd1' }
    ],

    zuege: [
      {
        spricht: 'absender',
        slots: [
          { rolle: 'adressat', text: 'An Alle',                regel: 'Der Adressat steht zuerst.' },
          { rolle: 'absender', text: 'von {absender.rufname}', regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',   text: 'Verbindungskontrolle',   regel: 'Die Inhaltsbezeichnung steht nach dem Absender.' },
          { rolle: 'aufruf',   text: '{erste.rufname}',        regel: 'Nach der Inhaltsbezeichnung wird die Station aufgerufen, die zuerst antwortet.' },
          { rolle: 'schluss',  text: 'antworten',              regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          // Falsch nach der Lage — sie sagt, wer zuerst antwortet.
          { text: '{zweite.rufname}', regel: 'Zuerst wird die Station aufgerufen, die laut Lage zuerst antwortet.', ersetzt: 'aufruf' }
        ]
      },
      {
        spricht: 'erste',
        slots: [
          { rolle: 'absender',          text: '{erste.rufname}',   regel: 'Wer antwortet, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung',       text: 'verstanden',        regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'verstaendlichkeit', text: '{ersteHoert.wort}', regel: 'Die Verständlichkeit folgt nach der Quittierung.' },
          { rolle: 'schluss',           text: 'antworten',         regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          { rolle: 'quittierung',       text: 'verstanden',        regel: 'Zuerst wird der Empfang bestätigt.' },
          { rolle: 'verstaendlichkeit', text: '{hoertErste.wort}', regel: 'Die Verständlichkeit folgt nach der Quittierung.' },
          { rolle: 'aufruf',            text: '{zweite.rufname}',  regel: 'Danach wird die nächste Station aufgerufen.' },
          { rolle: 'schluss',           text: 'antworten',         regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          // Falsch nach dem Ablauf — diese Station hat schon geantwortet.
          { text: '{erste.rufname}', regel: 'Aufgerufen wird die Station, die noch nicht geantwortet hat.', ersetzt: 'aufruf' }
        ]
      },
      {
        spricht: 'zweite',
        slots: [
          { rolle: 'absender',          text: '{zweite.rufname}',   regel: 'Wer antwortet, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung',       text: 'verstanden',         regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'verstaendlichkeit', text: '{zweiteHoert.wort}', regel: 'Die Verständlichkeit folgt nach der Quittierung.' },
          { rolle: 'schluss',           text: 'antworten',          regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          { rolle: 'quittierung',       text: 'verstanden',         regel: 'Zuerst wird der Empfang bestätigt.' },
          { rolle: 'verstaendlichkeit', text: '{hoertZweite.wort}', regel: 'Die Verständlichkeit folgt nach der Quittierung.' },
          { rolle: 'schluss',           text: 'Schluss',            regel: 'Schluss beendet die Übermittlung und steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: '{fremd2.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' }
        ]
      }
    ],

    kontext: '{absender.rufname} prüft die Verbindung zu allen Stationen im Netz: {erste.rufname} und {zweite.rufname}; {erste.rufname} antwortet zuerst. {erste.rufname} hört {absender.rufname} mit {ersteHoert.wort}, umgekehrt {hoertErste.wort}. {zweite.rufname} hört {absender.rufname} mit {zweiteHoert.wort}, umgekehrt {hoertZweite.wort}.'
  },

  // ─── Kanalwechsel (Behelf S. 13) ───────────────────────────────
  // "Auf den neuen Kanal wird erst umgestellt, wenn alle quittiert haben."
  // Der Behelf schreibt "Relais Rxxx"; hier steht die Kanalnummer aus
  // Kanaele.js, wie sie am Geraet eingestellt wird.
  // Ablenker, die nach einer Regel falsch sind: "auf deinen/meinen Befehl"
  // vertauscht, und "verstanden" statt "richtig" nach einer Quittierung.
  {
    id: 'kanalwechsel',
    name: 'Kanalwechsel',
    beschreibung: 'Befehl an alle, Quittierung, dann der Wechsel.',
    kategorie: 'kanalwechsel',

    rollen: [
      // Ein Kommandoposten fuehrt das Netz des Zivilschutzes.
      { name: 'absender', typ: 'stationen', wo: { leitet: true } },
      { name: 'erste',    typ: 'stationen', wo: { org: 'zivilschutz' }, nichtGleich: 'absender' },
      { name: 'zweite',   typ: 'stationen', wo: { org: 'zivilschutz' }, nichtGleich: ['absender', 'erste'] },
      { name: 'kanal',    typ: 'kanaele' },
      { name: 'fremd1',   typ: 'fremdwoerter' },
      { name: 'fremd2',   typ: 'fremdwoerter', nichtGleich: 'fremd1' }
    ],

    zuege: [
      {
        spricht: 'absender',
        slots: [
          { rolle: 'adressat', text: 'An Alle',                regel: 'Der Adressat steht zuerst.' },
          { rolle: 'absender', text: 'von {absender.rufname}', regel: 'Der Absender kommt nach dem Adressaten.' },
          { rolle: 'inhalt',   text: 'Kanalwechsel',           regel: 'Die Inhaltsbezeichnung steht nach dem Absender.' },
          { rolle: 'kanal',    text: 'auf {kanal.number}',     regel: 'Nach «Kanalwechsel» folgt der neue Kanal.' },
          { rolle: 'befehl',   text: 'auf meinen Befehl',      regel: '«auf meinen Befehl» folgt nach dem Kanal.' },
          { rolle: 'aufruf',   text: '{erste.rufname}',        regel: 'Danach wird die Station aufgerufen, die zuerst quittiert.' },
          { rolle: 'schluss',  text: 'antworten',              regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}',     regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: 'auf deinen Befehl', regel: 'Wer den Befehl gibt, sagt «auf meinen Befehl».', ersetzt: 'befehl' },
          { text: '{zweite.rufname}',  regel: 'Zuerst wird die Station aufgerufen, die laut Lage zuerst quittiert.', ersetzt: 'aufruf' }
        ]
      },
      {
        spricht: 'erste',
        slots: [
          { rolle: 'absender',    text: '{erste.rufname}',            regel: 'Wer quittiert, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung', text: 'verstanden',                 regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'kanal',       text: 'Wechsel auf {kanal.number}', regel: 'Der Befehl wird wiederholt: zuerst der Wechsel mit dem Kanal.' },
          { rolle: 'befehl',      text: 'auf deinen Befehl',          regel: '«auf deinen Befehl» folgt nach dem Kanal.' },
          { rolle: 'schluss',     text: 'antworten',                  regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}',     regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: 'auf meinen Befehl', regel: 'Wer quittiert, sagt «auf deinen Befehl». Der Befehl kommt von der Gegenstation.', ersetzt: 'befehl' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          { rolle: 'bestaetigung', text: 'richtig',          regel: 'Zuerst wird die Quittierung bestätigt.' },
          { rolle: 'aufruf',       text: '{zweite.rufname}', regel: 'Danach wird die nächste Station aufgerufen.' },
          { rolle: 'schluss',      text: 'antworten',        regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd2.wort}',   regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: 'verstanden',      regel: 'Eine fehlerfreie Quittierung wird mit «richtig» bestätigt, nicht mit «verstanden».', ersetzt: 'bestaetigung' },
          { text: '{erste.rufname}', regel: 'Aufgerufen wird die Station, die noch nicht quittiert hat.', ersetzt: 'aufruf' }
        ]
      },
      {
        spricht: 'zweite',
        slots: [
          { rolle: 'absender',    text: '{zweite.rufname}',           regel: 'Wer quittiert, nennt zuerst den eigenen Rufnamen.' },
          { rolle: 'quittierung', text: 'verstanden',                 regel: 'Nach dem eigenen Rufnamen folgt die Quittierung.' },
          { rolle: 'kanal',       text: 'Wechsel auf {kanal.number}', regel: 'Der Befehl wird wiederholt: zuerst der Wechsel mit dem Kanal.' },
          { rolle: 'befehl',      text: 'auf deinen Befehl',          regel: '«auf deinen Befehl» folgt nach dem Kanal.' },
          { rolle: 'schluss',     text: 'antworten',                  regel: 'Das Schlusswort steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd2.wort}',     regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: 'auf meinen Befehl', regel: 'Wer quittiert, sagt «auf deinen Befehl». Der Befehl kommt von der Gegenstation.', ersetzt: 'befehl' }
        ]
      },
      {
        spricht: 'absender',
        slots: [
          { rolle: 'bestaetigung', text: 'richtig',                    regel: 'Zuerst wird die Quittierung bestätigt.' },
          { rolle: 'kanal',        text: 'Wechsel auf {kanal.number}', regel: 'Nach «richtig» folgt der Wechsel mit dem Kanal.' },
          { rolle: 'befehl',       text: 'ausführen',                  regel: '«ausführen» folgt nach dem Kanal.' },
          { rolle: 'schluss',      text: 'Schluss',                    regel: 'Schluss beendet die Übermittlung und steht am Ende.' }
        ],
        ablenker: [
          { text: '{fremd1.wort}', regel: 'Es gelten nur die Redewendungen aus dem Behelf.', ersetzt: 'schluss' },
          { text: 'verstanden',    regel: 'Eine fehlerfreie Quittierung wird mit «richtig» bestätigt, nicht mit «verstanden».', ersetzt: 'bestaetigung' }
        ]
      }
    ],

    kontext: '{absender.rufname} befiehlt den Wechsel auf Kanal {kanal.number}. Im Netz sind {erste.rufname} und {zweite.rufname}; {erste.rufname} quittiert zuerst. Der Wechsel gilt erst, wenn alle quittiert haben.'
  }

]
